import { inspiration } from '../../data/homepageData';
import { ResponsiveImage } from '../ui/ResponsiveImage';

export function InspirationGallery() {
  return (
    <section id="inspiration" className="section inspiration-section">
      <div className="section-heading-row">
        <h2>Inspirace</h2>
        <a href="#inspiration">Zobrazit více inspirace →</a>
      </div>
      <div className="inspiration-strip">
        {inspiration.map((src, index) => (
          <ResponsiveImage key={src} srcBase={src} alt={`Inspirace pro Calendar Studio ${index + 1}`} className="inspiration-strip__image" sizes="(max-width: 768px) 80vw, 220px" />
        ))}
      </div>
    </section>
  );
}
